import _isEmpty from 'lodash/isEmpty';

import { getPageUrl, isExternalPage } from 'components/modules/website-component-interaction/utils';
import { multiCaseGet } from 'libs/format';

export function getInitialFormData(placeAction, pages) {
  const { objectId: pageId, attributes } = placeAction || {};
  const { uri, isPreferred } = attributes || {};

  const page = pages.find((p) => p.id === pageId);
  const pageUrl = getPageUrl(page);

  const url = !_isEmpty(page) ? pageUrl : uri;

  return {
    uri: url || '',
    isPreferred: isPreferred || false,
  };
}

export function getDropdownText(page) {
  if (page && !isExternalPage(page)) {
    const pageTitle = multiCaseGet(page, 'title') || multiCaseGet(page, 'pageType');
    return pageTitle ? `"${pageTitle}" Link` : '';
  }

  return 'Custom Link';
}
